import { render, staticRenderFns } from "./AdminOrgGroup.vue?vue&type=template&id=165db726&scoped=true&"
import script from "./AdminOrgGroup.vue?vue&type=script&lang=js&"
export * from "./AdminOrgGroup.vue?vue&type=script&lang=js&"
import style0 from "./AdminOrgGroup.vue?vue&type=style&index=0&id=165db726&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165db726",
  null
  
)

export default component.exports